import { clientConnectorConstants } from "../constants/clientConnector.constants";

export function clientConnector(state = {}, action) {
  switch (action.type) {
    case clientConnectorConstants.GET_REQUEST:
    case clientConnectorConstants.UPDATE_REQUEST:
    case clientConnectorConstants.CREATE_REQUEST:
      return {
        ...state,
        loading: true,
        request: action.payload,
        error: false,
        success: false,
        deleteError: null,
        deleteSuccess: false,
      };
    case clientConnectorConstants.GET_SUCCESS:
      return {
        ...state,
        loading: false,
        paginatedResult: action.payload,
      };
    case clientConnectorConstants.UPDATE_SUCCESS:
    case clientConnectorConstants.CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };
    case clientConnectorConstants.GET_FAILURE:
    case clientConnectorConstants.UPDATE_FAILURE:
    case clientConnectorConstants.CREATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        paginatedResult: {},
      };
    case clientConnectorConstants.CLEAR_SUGGESTIONS_REQUEST:
    case clientConnectorConstants.GET_SUGGESTIONS_REQUEST:
    case clientConnectorConstants.GET_SUGGESTIONS_FAILURE:
      return {
        ...state,
        suggestions: {},
      };
    case clientConnectorConstants.GET_SUGGESTIONS_SUCCESS:
      return {
        ...state,
        suggestions: action.payload,
      };
    case clientConnectorConstants.DELETE_REQUEST:
      return {
        ...state,
        deleting: true,
        deleteError: null,
        deleteSuccess: false,
      };
    case clientConnectorConstants.DELETE_SUCCESS:
      return {
        ...state,
        deleting: false,
        deleteSuccess: true,
      };
    case clientConnectorConstants.DELETE_FAILURE:
      return {
        ...state,
        deleting: false,
        deleteError: action.payload,
      };
    case clientConnectorConstants.TEST_AUTH_REQUEST:
      return {
        ...state,
        loadingTestAuth: true,
        request: action.payload,
        testAuthResponse: null,
        testAuthError: null,
      };
    case clientConnectorConstants.TEST_AUTH_SUCCESS:
      return {
        ...state,
        loadingTestAuth: false,
        testAuthResponse: action.payload,
        testAuthError: null,
      };
    case clientConnectorConstants.TEST_AUTH_FAILURE:
      return {
        ...state,
        loadingTestAuth: false,
        testAuthResponse: null,
        testAuthError: action.payload,
      };
    case clientConnectorConstants.PUSH_ONPREM_UPDATE_REQUEST:
      return {
        ...state,
        pushingOnPremUpdate: true,
        pushOnPremUpdateSuccess: false,
        pushOnPremUpdateError: null,
      };
    case clientConnectorConstants.PUSH_ONPREM_UPDATE_SUCCESS:
      return {
        ...state,
        pushingOnPremUpdate: false,
        pushOnPremUpdateSuccess: true,
        pushOnPremUpdateError: null,
      };
    case clientConnectorConstants.PUSH_ONPREM_UPDATE_FAILURE:
      return {
        ...state,
        pushingOnPremUpdate: false,
        pushOnPremUpdateSuccess: false,
        pushOnPremUpdateError: action.payload,
      };
    default:
      return state;
  }
}
